import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Venta } from 'src/app/model/index.model';
import { VentaService } from 'src/app/service/index.service';
import { Router } from '@angular/router';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import Swal from 'sweetalert2';
import { FilVentaUsuarioComponent } from '../../filtro/fil-venta-usuario/fil-venta-usuario.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EstadoVentaComponent } from '../../custom/estado-venta/estado-venta.component';

@Component({
  selector: 'app-lst-venta',
  templateUrl: './lst-venta.component.html',
  styleUrls: ['./lst-venta.component.scss']
})
export class LstVentaComponent implements OnInit, AfterViewInit {


  @ViewChild('filtro', { static: false }) fil: any; // o tipo base si comparten interfaz
  entity = "Ventas"

  items: Venta[];
  item: Venta;

  totalT: number = 0
  totalD: number = 0
  totalC: number = 0


  proccess: Boolean;

  user: any;

  constructor(
    private modalService: NgbModal,
    private wsdl: VentaService,
    private router: Router) {
    this.item = new Venta();
    this.user = JSON.parse(UturuncoUtils.getSession("user"))
  }

  ngOnInit() {

  }
  ngAfterViewInit() {
    // Asegurate de que esté definido antes de usarlo
    if (this.fil) {
      this.fil.list();
    }
  }
  preNew() {
    this.item = new Venta();
  }

  select(item: Venta) {
    this.item = item;
  }

  cancel() {
    this.item = new Venta();
    this.fil.list();
  }

  async setResultCancel(event: boolean) {
    UturuncoUtils.showToas("Operación cancelada", "info");
  }

  setResult(event: any) {
    this.cancel();
  }

  preDelete(item: Venta) {
    this.item = new Venta();
    this.item = item;

    Swal.fire({
      title: 'Esta Seguro?',
      text: '¡No podrás recuperar este archivo ' + item.cliente + '!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Sí, bórralo!',
      cancelButtonText: 'No, mantenlo',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.value) {
        this.delete()
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        UturuncoUtils.showToas('Tu archivo esta seguro :)', "warning")

      }
    })
  }


  async entregar(item) {
    const modalRef = this.modalService.open(EstadoVentaComponent, {
      size: 'md',
      centered: true,
      keyboard: true       // permite cerrar con ESC
    });
    modalRef.componentInstance.item = item;
    modalRef.result.then(
      result => {
        console.log('Modal cerrado con:', result);
      },
      reason => {
        console.log('Modal descartado con:', reason);
      }
    );

  }


  async delete() {
    try {
      this.proccess = true;
      const res = await this.wsdl.doDelete(this.item.id).then();
      const result = JSON.parse(JSON.stringify(res));
      if (result.code == 200) {
        UturuncoUtils.showToas(result.msg, "success");
        this.cancel();
      } else {
        UturuncoUtils.showToas(result.msg, "error");
      }
    } catch (error) {
      UturuncoUtils.showToas("Excepción: " + error.message, "error");
    }
    this.proccess = false;
  }

  doFound(event: Venta[]) {
    this.items = event;

    this.totalC = 0
    this.totalD = 0
    this.totalT = 0

    this.items.forEach(element => {
      this.totalC += element.condicion == 'contado' ? parseFloat("" + element.total) : 0
      this.totalT += element.condicion == 'tarjeta' ? parseFloat("" + element.total) : 0
      this.totalD += element.condicion == 'mayorista' ? parseFloat("" + element.total) : 0
    });
  }

  linkear(id?: number) {
    this.router.navigateByUrl("admin/" + this.entity.toLocaleLowerCase() + "/abm/" + id);
  }

  gestionar(id?: number) {
    this.router.navigateByUrl("admin/detalleVentas/gst/" + id);

  }

  imprimir(id?: number) {
    this.router.navigateByUrl("admin/detalleVentas/imprimir/" + id);

  }

}
